class LsTopBar extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-ls-top-bar-track]');
    this.items = Array.from(this.querySelectorAll('[data-ls-top-bar-item]'));
    this.currentIndex = 0;
    this.mobileQuery = window.matchMedia('(max-width: 749px)');
    this.interval = Number(this.dataset.interval) || 4500;

    this.handleViewportChange = () => this.updateMode();
    this.mobileQuery.addEventListener('change', this.handleViewportChange);
    this.addEventListener('mouseenter', () => this.stopRotation());
    this.addEventListener('mouseleave', () => this.startRotation());
    this.addEventListener('focusin', () => this.stopRotation());
    this.addEventListener('focusout', () => this.startRotation());
    this.updateMode();
  }

  disconnectedCallback() {
    this.stopRotation();
    this.mobileQuery?.removeEventListener('change', this.handleViewportChange);
  }

  updateMode() {
    this.stopRotation();
    this.currentIndex = 0;
    this.render();

    if (this.mobileQuery.matches && this.items.length > 1) {
      this.startRotation();
    }
  }

  startRotation() {
    if (!this.mobileQuery?.matches || this.items.length < 2 || this.rotationTimer) return;

    this.rotationTimer = window.setInterval(() => {
      this.currentIndex = (this.currentIndex + 1) % this.items.length;
      this.render();
    }, this.interval);
  }

  stopRotation() {
    window.clearInterval(this.rotationTimer);
    this.rotationTimer = null;
  }

  render() {
    if (!this.track) return;

    const isMobile = this.mobileQuery.matches;
    this.track.style.transform = isMobile ? `translateX(-${this.currentIndex * 100}%)` : '';

    this.items.forEach((item, index) => {
      if (isMobile) {
        item.setAttribute('aria-hidden', index === this.currentIndex ? 'false' : 'true');
        item.toggleAttribute('inert', index !== this.currentIndex);
      } else {
        item.removeAttribute('aria-hidden');
        item.removeAttribute('inert');
      }
    });
  }
}

if (!customElements.get('ls-top-bar')) {
  customElements.define('ls-top-bar', LsTopBar);
}
